import {MBranch} from '../../../service/m-branch/model/m-branch';

export class MStore {
  indexNo: number;
  name: string;
  number: number;
  type: string;
  mBranch: MBranch;
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-store/model/m-store.ts